import { SectionBackground } from '../components/layout/SectionBackground';
import { HeroSection } from '../components/hero/HeroSection';
import { PlantCareSection } from '../components/care/PlantCareSection';
import { BuyMeCoffee } from '../components/support/BuyMeCoffee';
import { MetaTags } from '../components/seo/MetaTags';
import { CTASection } from '../components/hero/CTASection';
import { ProductShowcase } from '../components/product/ProductShowcase';

export function Home() {
  return (
    <>
      <MetaTags />
      <main className="pt-16">
        <SectionBackground variant="hero">
          <HeroSection />
        </SectionBackground>

        <SectionBackground variant="capture">
          <CTASection />
        </SectionBackground>

        <ProductShowcase />

        <SectionBackground variant="care">
          <PlantCareSection />
        </SectionBackground>

        <BuyMeCoffee />
      </main>
    </>
  );
}
